import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  ExclusionsRequestInterface,
  ExclusionsResponseInterface,
  Group
} from '@interfaces';

@Injectable({
  providedIn: 'root',
})
export class ExclusionsService {
  constructor() {}

  searchExclusions(
    query: ExclusionsRequestInterface,benefitTool:Group
  ): Observable<ExclusionsResponseInterface> {
    const response: ExclusionsResponseInterface = benefitTool[0];
    return of(response);
  }
}
